// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: white;
  min-height: calc(100vh - 64px);
}

.sidenav {
  padding: 20px;
}

mat-drawer-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

#menu {
  background: #267833;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".container {\n  background-color: white;\n  min-height: calc(100vh - 64px);\n}\n\n.sidenav {\n  padding: 20px;\n}\n\nmat-drawer-container {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n#menu {\n  background: #267833;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
